'use client'

import { CloseBtn } from 'modules/components'
import { useStopBodyScroll } from 'modules/client'
import { motion } from 'framer-motion'
import React, { PropsWithChildren, useRef } from 'react'
import { createPortal } from 'react-dom'
import { cn } from 'modules/utils'

interface Props {
  onClose: () => void
  className?: string
}

export default function Modal(props: PropsWithChildren<Props>) {
  const dialogRef = useRef<HTMLDivElement>(null)

  const { className, onClose } = props

  useStopBodyScroll()

  function onDismiss() {
    onClose()
  }

  return createPortal(
    <div className="flex-center bg-modal-overlay fixed inset-0 z-50 text-white">
      <div
        ref={dialogRef}
        className={cn(
          'flex-center bg-modal-bg fixed mx-auto rounded-2xl border-none p-5',
          'min-w-5xl h-[70vh] w-[60vw] max-w-7xl text-white',
          className,
        )}
      >
        <motion.div
          className="h-full w-full"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
        >
          {props.children}
        </motion.div>
        <CloseBtn onClose={onDismiss} className="absolute right-6 top-6" size={36} />
      </div>
    </div>,
    document.getElementById('modal-root')!,
  )
}
